// hooks/useCartState.ts
import { useState } from "react";
import { Productbtn } from "../../../../../../shared/services/interfacev2";

export const useCartState = () => {
  const [selectedProductslist, setSelectedProductslist] = useState<Productbtn[]>([]);
  const [valueMap, setValueMap] = useState<{ [id: string]: number }>({});
  const [condition, setCondition] = useState<number>(0);
  const [deliveryFee, setDeliveryFee] = useState<number>(0);

  return {
    selectedProductslist,
    setSelectedProductslist,
    valueMap,
    setValueMap,
    condition,
    setCondition,
    deliveryFee,
    setDeliveryFee,
  };
};
